import React from 'react'
import * as R from 'remeda'

import {
  SurveyGroupCustomerAttributeConditionalSelector,
  type SurveyGroupCustomerAttributeConditionalSelectorProps,
} from '~/components/features/SurveyGroupCustomerAttributeConditionalSelector'
import { type ConditionOperation } from '~/gql/graphql'
import { intersectionBy } from '~/utils'

import { type SurveyGroupCustomerAttribute } from '../utils'

export type CustomerAttributesInputProps = {
  conditionOperation: ConditionOperation
  customerAttributes: SurveyGroupCustomerAttribute[]
  value: SurveyGroupCustomerAttribute[]
  onBlur: () => void
  onChange: (value: SurveyGroupCustomerAttribute[]) => void
}

export const CustomerAttributesInput = React.forwardRef<
  HTMLDivElement,
  CustomerAttributesInputProps
>(
  (
    { conditionOperation, customerAttributes, onBlur, onChange, value },
    ref,
  ) => {
    const handleChange = React.useCallback<
      EH<
        SurveyGroupCustomerAttributeConditionalSelectorProps<SurveyGroupCustomerAttribute>,
        'onChange'
      >
    >(
      (customerAttributeIdLikes) => {
        onChange(
          intersectionBy(
            customerAttributes,
            customerAttributeIdLikes,
            R.prop('idLike'),
            R.identity(),
          ),
        )
      },
      [customerAttributes, onChange],
    )

    return (
      <SurveyGroupCustomerAttributeConditionalSelector
        ref={ref}
        conditionOperation={conditionOperation}
        customerAttributes={customerAttributes}
        value={value.map(R.prop('idLike'))}
        onBlur={onBlur}
        onChange={handleChange}
      />
    )
  },
)
